<div class="login-container" [@fadeInOut]>
  <p-toast></p-toast>

  <!-- Dark Mode Toggle -->
  <div class="dark-mode-toggle">
    <p-button
      [icon]="isDarkMode() ? 'pi pi-sun' : 'pi pi-moon'"
      [text]="true"
      (click)="toggleDarkMode()"
      [pTooltip]="isDarkMode() ? 'Switch to Light Mode' : 'Switch to Dark Mode'"
      tooltipPosition="bottom"
    ></p-button>
  </div>

  <div class="login-wrapper">
    <div class="login-image-side">
      <img src="/login_logo.png" alt="Logo" class="login-logo" />
    </div>

    <div class="login-form-side">
      <div class="login-header">
        <h2>Please sign in to continue</h2>
      </div>

      <form [formGroup]="loginForm">
        <div>
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="pi pi-user"></i>
            </p-inputgroup-addon>
            <p-floatlabel variant="on">
              <input pInputText id="username" formControlName="username" />
              <label for="username">Username</label>
            </p-floatlabel>
          </p-inputgroup>
        </div>
        <div>
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="pi pi-key"></i>
            </p-inputgroup-addon>
            <p-floatlabel variant="on">
              <input pPassword id="password" type="password" formControlName="password" [feedback]="false" />
              <label for="password">Password</label>
            </p-floatlabel>
          </p-inputgroup>
        </div>

        <button pButton type="submit" (click)="submit()" [disabled]="loginForm.invalid || (isLoading$ | async)"
          [loading]="(isLoading$ | async) || false" class="submit-btn">
          <span pButtonLabel>Sign In</span>
          <i pButtonIcon class="pi pi-sign-in"></i>
        </button>

<!--        <p-divider>-->
<!--          <b>or</b>-->
<!--        </p-divider>-->

<!--        <button pButton severity="secondary" [disabled]="(isLoading$ | async)" [loading]="(isLoading$ | async) || false"-->
<!--          class="sso-btn">-->
<!--          <span pButtonLabel>Continue with SSO</span>-->
<!--          <i pButtonIcon class="pi pi-google"></i>-->
<!--        </button>-->
      </form>
    </div>
  </div>
</div>
